import {
  REQUEST_SALES_ORDERS,
  FETCH_SALES_ORDERS_SUCCESS,
  FETCH_SALES_ORDERS_FAILURE,
  SELECT_SALES_ORDER,
  RESET_CURRENT_SALES_ORDER,
  REQUEST_SALES_ORDER_DETAIL,
  FETCH_SALES_ORDER_DETAIL_SUCCESS,
  FETCH_SALES_ORDER_DETAIL_FAILURE,
  REQUEST_SALES_ORDER_DETAIL_BY_NUM,
  FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS,
  FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE,
  REQUEST_CREATING_SALES_ORDER,
  CREATE_SALES_ORDER_SUCCESS,
  CREATE_SALES_ORDER_FAILURE,
  REQUEST_EDITING_SALES_ORDER,
  EDIT_SALES_ORDER_SUCCESS,
  EDIT_SALES_ORDER_FAILURE,
  REQUEST_VOID_SALES_ORDER,
  VOID_SALES_ORDER_SUCCESS,
  VOID_SALES_ORDER_FAILURE,
  REQUEST_CUSTOMER_SALES_HISTORY,
  FETCH_CUSTOMER_SALES_HISTORY_SUCCESS,
  FETCH_CUSTOMER_SALES_HISTORY_FAILURE,
  REQUEST_CUSTOMER_ORDER_SCHEDULES,
  FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS,
  FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE,
  REQUEST_TODAYS_OUTGOING_ORDERS,
  FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS,
  FETCH_TODAYS_OUTGOING_ORDERS_FAILURE,
  REQUEST_SALES_ORDER_LINE_WEIGHTS,
  FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS,
  FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE,
  REQUEST_SET_ORDER_LINE_WEIGHTS,
  EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS,
  EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE,
  CLEAR_SALES_ORDER_LINE_WEIGHTS,
  REQUEST_SALES_ORDER_FORM,
  FETCH_SALES_ORDER_FORM_SUCCESS,
  FETCH_SALES_ORDER_FORM_FAILURE,
  REQUEST_SALES_CSV,
  FETCH_SALES_CSV_SUCCESS,
  FETCH_SALES_CSV_FAILURE,
  REQUEST_SAVE_POS_SALE,
  SAVE_POS_SALE_SUCCESS,
  SAVE_POS_SALE_FAILURE,
  INVALID_CHARACTER_ENTERED,
  CLEAR_ERROR_MESSAGE_IN_POS,
  CHARGE_NOT_MET,
  START_NEW_ORDER,
  REQUEST_DRAFT_DETAILS,
  LOAD_DRAFT_SUCCESS,
  LOAD_DRAFT_FAILURE,
  REQUEST_DRAFTS,
  FETCH_DRAFTS_SUCCESSFUL,
  FETCH_DRAFTS_FAILURE,
  REQUEST_CUSTOMER_PRICES,
  FETCH_CUSTOMER_PRICES_SUCCESS,
  FETCH_CUSTOMER_PRICES_FAILURE,
  REQUEST_CURRENCY_RATES,
  FETCH_CURRENCY_RATES_SUCCESS,
  FETCH_CURRENCY_RATES_FAILURE,
  EDIT_MULTI_CURRENCIES,
  EDIT_MULTI_CURRENCIES_SUCCESS,
  EDIT_MULTI_CURRENCIES_FAILURE,
  REQUEST_TAX_RATES,
  FETCH_TAX_RATES_SUCCESS,
  FETCH_TAX_RATES_FAILURE,
  REQUEST_CREATE_TAX_RATE,
  CREATE_TAX_RATE_SUCCESS,
  CREATE_TAX_RATE_FAILURE,
  EDIT_MULTI_TAXES,
  EDIT_MULTI_TAXES_SUCCESS,
  EDIT_MULTI_TAXES_FAILURE,
  DELETE_TAX,
  DELETE_TAX_SUCCESS,
  DELETE_TAX_FAILURE,
  REQUEST_OVERALL_SALES_PERFORMANCE,
  FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS,
  FETCH_OVERALL_SALES_PERFORMANCE_FAILURE,
  REQUEST_POS_REPORT,
  FETCH_POS_REPORT_SUCCESS,
  FETCH_POS_REPORT_FAILURE,
  REQUEST_SALES_INVENTORY_INFO,
  FETCH_SALES_INVENTORY_INFO_SUCCESS,
  FETCH_SALES_INVENTORY_INFO_FAILURE,
  REQUEST_SALES_CUSTOMER_DETAIL,
  FETCH_SALES_CUSTOMER_DETAIL_SUCCESS,
  FETCH_SALES_CUSTOMER_DETAIL_FAILURE,
  REQUEST_SHIPPING_DETAIL,
  FETCH_SHIPPING_DETAIL_SUCCESS,
  FETCH_SHIPPING_DETAIL_FAILURE,
  REQUEST_PURCHASES_VENDOR_DETAIL,
  FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS,
  FETCH_PURCHASES_VENDOR_DETAIL_FAILURE,
  CLEAR_SALES_CUSTOMER_DETAILS,
  SET_SALES_ORDERS_FILTER,
  REQUEST_ITEM_SALES_HISTORY,
  FETCH_ITEM_SALES_HISTORY_SUCCESS,
  FETCH_ITEM_SALES_HISTORY_FAILURE,
  REQUEST_CUSTOMER_FREQUENT,
  FETCH_CUSTOMER_FREQUENT_SUCCESS,
  FETCH_CUSTOMER_FREQUENT_FAILURE,
  REQUEST_SALES_PERFORMANCE,
  REQUEST_SALES_PERFORMANCE_BY_FILTER,
  REQUEST_SALES_PERFORMANCE_SUCCESS,
  REQUEST_SALES_PERFORMANCE_FAILURE,
  REQUEST_USER_PERFORMANCE_BY_FILTER,
  REQUEST_USER_PERFORMANCE_SUCCESS,
  REQUEST_USER_PERFORMANCE_FAILURE,
  REQUEST_SALES_DASHBOARD_DETAIL,
  FETCH_SALES_DASHBOARD_DETAIL_SUCCESS,
  FETCH_SALES_DASHBOARD_DETAIL_FAILURE,
  REQUEST_SALES_LEVELS,
  FETCH_SALES_LEVELS_SUCCESS,
  FETCH_SALES_LEVELS_FAILURE,
  REQUEST_REFUND,
  REQUEST_REFUND_SUCCESS,
  REQUEST_REFUND_FAILURE,
  REQUEST_SHIPPING_LIST_PDF,
  FETCH_SHIPPING_LIST_SUCCESS,
  REMOVE_SHIPPING_PDF,
  REQUEST_PACKING_LIST_PDF,
  FETCH_PACKING_LIST_SUCCESS,
  REQUEST_SO_PDF,
  FETCH_SO_PDF_SUCCESS,
  REQUEST_SO_SI_PDF,
  FETCH_SO_SI_PDF_SUCCESS,
  REQUEST_BOL_ID_PDF,
  FETCH_BOL_ID_PDF_SUCCESS,
  REQUEST_BOL_WITHOUT_LOG,
  FETCH_BOL_WITHOUT_LOG_SUCCESS,
  REQUEST_BOL_LABEL,
  FETCH_BOL_LABEL_SUCCESS,
  REQUEST_BOL_FBA_PDF,

  FETCH_SP_SUCCESS,
  REQUEST_SP_PDF,

  FETCH_BOL_FBA_PDF_SUCCESS,
  FETCH_BOL_ADDRESS_SUCCESS,
  REQUEST_REFUND_PDF,
  REQUEST_REFUND_PDF_SUCCESS,
  REQUEST_PICKING_LIST_PDF,
  FETCH_PICKING_LIST_SUCCESS,
  REQUEST_PRODUCT_BY_ID,
  FETCH_PRODUCT_BY_ID_SUCCESS,
  FETCH_PRODUCT_BY_ID_FAILURE,
  KEEP_EST_DATE,
  FINISHED_UNMOUNT,
  DESTROY_EST_DATE,
  FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS,
  REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL,
  REQUEST_SALES_TOTALS,
  FETCH_SALES_TOTALS_SUCCESS,
  FETCH_SALES_TOTALS_FAILURE,
  REQUEST_SALES_ORDERS_BY_FILTER,
  REQUEST_SALES_ORDER_TO_QUOTE,
  SALES_ORDER_TO_QUOTE_SUCCESS,
  SALES_ORDER_TO_QUOTE_FAILURE,
  REQUEST_SALES_QUOTE_TO_OPEN,
  REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS,
  REQUEST_SALES_QUOTE_TO_ORDER_FAILURE,
  REQUEST_SET_SHIPPING_WEIGHT,
  REQUEST_SET_SHIPPING_WEIGHT_SPLIT,
  UPDATE_SHIPPING_WEIGHT_SUCCESS,
  UPDATE_SHIPPING_WEIGHT_FAILURE,
  UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO,
  SALES_ORDER_FORM_BATCHES,
} from '../actions/type';

const INITIAL_STATE = {
  msoTotalPages: null,
  all: null,
  currentSalesOrder: null,
  currentSalesOrderDetail: null,
  currentSalesOrderDetailByNum: null,
  isLoading: true,
  error: null,
  detailIsLoading: false,
  detailByNumIsLoading: false,
  detailError: null,
  detailByNumError: null,
  salesOrderIsCreating: false,
  salesOrderCreateError: null,
  salesOrderCreated: false,
  salesOrderIsEditing: false,
  salesOrderEditError: null,
  salesOrderEdited: false,
  customerOrderSchedules: [],
  customerOrderSchedulesIsLoading: false,
  customerOrderSchedulesError: null,
  todaysOutgoingOrders: [],
  todaysOutgoingOrdersIsLoading: null,
  todaysOutgoingOrdersError: null,
  salesOrderLineWeights: [],
  salesOrderLineWeightsIsLoading: false,
  salesOrderLineWeightsError: null,
  salesOrderLineWeightsIsEditing: false,
  editSalesOrderLineWeightsError: null,
  editSalesOrderLineWeightsSuccess: false,
  printForm: null,
  printFormIsLoading: false,
  printFormError: null,
  csv: null,
  csvIsLoading: false,
  csvError: null,
  SavingPosSale: false,
  SavePosSaleSuccessful: null,
  SavePosSaleFailure: null,
  SavePosError: null,
  InvalidCharacterEntered: false,
  ChargeNotMet: false,
  RequestingDraft: null,
  DraftDetails: null,
  DraftError: null,
  drafts: null,
  draftsIsLoading: null,
  draftsError: null,
  customerPricesIsLoading: false,
  customerPricesError: null,
  customerPrices: [],
  currencyRates: null,
  currencyRatesIsLoading: false,
  currencyRatesError: null,
  multiCurrenciesIsEditing: false,
  multiCurrenciesEdited: false,
  multiCurrenciesEditError: null,
  taxRates: null,
  taxRatesIsLoading: false,
  taxRatesError: null,
  creatingTaxRate: false,
  createTaxRateError: null,
  createTaxRateSuccess: null,
  multiTaxesIsEditing: false,
  multiTaxesEdited: false,
  multiTaxesEditError: null,
  taxIsDeleting: false,
  taxDeleted: false,
  taxDeleteError: null,
  overallSales: [],
  overallSalesIsLoading: false,
  overallSalesError: null,
  posReport: [],
  posReportIsLoading: false,
  posReportError: null,
  salesInventoryInfo: [],
  salesInventoryInfoIsLoading: false,
  salesInventoryInfoError: null,
  salesCustomerDetails: null,
  salesShippingCustomerDetails: null,
  salesCustomerDetailsIsLoading: false,
  allShipping: null,
  allShippingIsLoading: false,
  allShippingError: null,
  purchasesVendorDetailsError: null,
  purchasesVendorDetails: null,
  purchasesVendorDetailsIsLoading: false,
  salesCustomerDetailsError: null,
  salesItemHistory: [],
  salesItemHistoryIsLoading: false,
  salesItemHistoryError: null,
  customerSalesHistory: [],
  customerSalesHistoryIsLoading: false,
  customerSalesHistoryError: null,
  customerFrequent: [],
  customerFrequentIsLoading: false,
  customerFrequentError: null,
  salesOrdersFilter: null,
  salesPerformanceIsLoading: false,
  salesPerformance: null,
  salesPerformanceError: null,
  dashboardSalesDetail: null,
  dashboardSalesDetailIsLoading: false,
  dashboardSalesDetailError: null,
  salesLevels: {},
  salesLevelsIsLoading: false,
  salesLevelsError: null,
  salesOrderProduct: null,
  salesOrderProductIsLoading: false,
  salesOrderProductFailure: null,

  requestingShippingList: false,
  shippingListPDF: null,
  requestingPackingList: false,
  packingListPDF: null,
  requestingPickingList: false,
  pickingListPDF: null,
  requestingSalesOrderPDF: false,
  salesOrderPDF: null,
  requestingBolIdPDF: false,
  bolIdPDF: null,
  requestingBolWithoutLogPDF: false,
  bolWithoutLogPDF: null,
  requestingBolLabel: false,
  bolLabel: null,
  requestingBolFbaPDF: false,
  bolFbaPDF: null,
  spPDF: null,
  bolAddress: [],
  requestingRefundPDF: false,
  refundPDF: null,
  prevEstDate: null,
  prevEstDateIsNeeded: false,
  // Refund related reducer
  refund: { error: null, loading: false, status: 0 },
  quoteLoading: false,
  salesTotals: null,
  salesTotalsIsLoading: false,
  salesTotalsError: null,
  userPerformanceIsLoading: false,
  userPerformanceError: null,
  userPerformanceData: {},
  batchesInfo: {},
  promotions: [],
};

export default function (state = INITIAL_STATE, action) {
  // console.log("action.payload:", action);
  switch (action.type) {
    case 'salesOrderForm/productpromotionfetching':
      return {
        ...state,
        promotions: [],
      }
    case 'salesOrderForm/productpromotion':
      return {
        ...state,
        promotions: action.payload,
      }
    case REQUEST_SET_SHIPPING_WEIGHT:
    case UPDATE_SHIPPING_WEIGHT_SUCCESS:
    case UPDATE_SHIPPING_WEIGHT_FAILURE:
    case REQUEST_SET_SHIPPING_WEIGHT_SPLIT:
    // Product action handlers
    case REQUEST_SALES_ORDERS_BY_FILTER:
    case REQUEST_SALES_ORDERS:
      return { ...state, error: null, isLoading: true };
    case FETCH_SALES_ORDERS_SUCCESS:
      return {
        ...state, all: action.payload.data, error: null, isLoading: false, msoTotalPages: action.payload.data ? action.payload.data.pages : 1,
      };
    case FETCH_SALES_ORDERS_FAILURE: {
      const error = action.payload || { message: action.payload.message };
      return {
        ...state, all: null, error, isLoading: false,
      };
    }
    case SELECT_SALES_ORDER:
      return { ...state, currentSalesOrder: action.payload };
    case RESET_CURRENT_SALES_ORDER:
      return {
        ...state, currentSalesOrder: null, currentSalesOrderDetail: null, salesCustomerDetails: null, refund: { error: null, loading: false, status: 0 },
      };
    case REQUEST_SALES_ORDER_DETAIL:
      return {
        ...state, detailError: null, detailIsLoading: true, currentSalesOrderDetail: null,
      };
    case FETCH_SALES_ORDER_DETAIL_SUCCESS:// return list of posts and make loading = false
      return {
        ...state, currentSalesOrderDetail: action.payload, detailError: null, detailIsLoading: false,
      };
    case FETCH_SALES_ORDER_DETAIL_FAILURE: {
      // return error and make loading = false
      const detailError = action.payload || { message: action.payload.message };// 2nd one is network or server down errors
      return {
        ...state, all: [], detailError, detailIsLoading: false,
      };
    }
    case REQUEST_SALES_ORDER_DETAIL_BY_NUM:
      return {
        ...state, detailByNumError: null, detailByNumIsLoading: true, currentSalesOrderDetailByNum: null,
      };
    case FETCH_SALES_ORDER_DETAIL_BY_NUM_SUCCESS:// return list of posts and make loading = false
      return {
        ...state, currentSalesOrderDetailByNum: action.payload, detailByNumError: null, detailByNumIsLoading: false,
      };
    case FETCH_SALES_ORDER_DETAIL_BY_NUM_FAILURE: {
      // return error and make loading = false
      const detailByNumError = action.payload || { message: action.payload.message };// 2nd one is network or server down errors
      alert('Sales Order Number does not exist');
      return {
        ...state, currentSalesOrderDetailByNum: null, detailByNumError, detailByNumIsLoading: false,
      };
    }
    case REQUEST_CREATING_SALES_ORDER:
      return {
        ...state, salesOrderIsCreating: true, salesOrderCreateError: null, salesOrderCreated: false,
      };
    case CREATE_SALES_ORDER_SUCCESS:
      return {
        ...state, salesOrderIsCreating: false, salesOrderCreateError: null, salesOrderCreated: action.payload.data,
      };
    case CREATE_SALES_ORDER_FAILURE: {
      const salesOrderCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
      alert(JSON.stringify(salesOrderCreateError));
      // alert('Please fill out all the fields');
      return {
        ...state, salesOrderIsCreating: false, salesOrderCreateError, salesOrderCreated: false,
      };
    }
    case REQUEST_EDITING_SALES_ORDER:
      return {
        ...state, salesOrderIsEditing: true, salesOrderEditError: null, salesOrderEdited: false, salesOrderCreated: false,
      };
    case EDIT_SALES_ORDER_SUCCESS:
      return {
        ...state, salesOrderIsEditing: false, salesOrderEditError: null, salesOrderEdited: action.payload.data, salesOrderCreated: action.payload.data,
      };
    case EDIT_SALES_ORDER_FAILURE: {
      const salesOrderEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
      alert(JSON.stringify(salesOrderEditError));
      return {
        ...state, salesOrderIsEditing: false, salesOrderEditError, salesOrderEdited: false, salesOrderCreated: false,
      };
    }
    case REQUEST_VOID_SALES_ORDER:
      return { ...state, error: null, isLoading: true };
    case VOID_SALES_ORDER_SUCCESS:
      return { ...state, isLoading: false };
    case VOID_SALES_ORDER_FAILURE: {
      const voidSalesOrderError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(voidSalesOrderError));
      return { ...state, voidSalesOrderError, isLoading: false };
    }
    case REQUEST_CUSTOMER_SALES_HISTORY:
      return { ...state, customerSalesHistoryIsLoading: true, customerSalesHistoryError: null };
    case FETCH_CUSTOMER_SALES_HISTORY_SUCCESS:
      return { ...state, customerSalesHistory: action.payload.data, customerSalesHistoryIsLoading: false };
    case FETCH_CUSTOMER_SALES_HISTORY_FAILURE: {
      const customerSalesHistoryError = action.payload.data || { message: action.payload.message };
      return { ...state, customerSalesHistoryError, customerSalesHistoryIsLoading: false };
    }
    case REQUEST_CUSTOMER_ORDER_SCHEDULES:
      return { ...state, customerOrderSchedulesIsLoading: true, customerOrderSchedulesError: null };
    case FETCH_CUSTOMER_ORDER_SCHEDULES_SUCCESS:
      return { ...state, customerOrderSchedulesIsLoading: false, customerOrderSchedules: action.payload.data };
    case FETCH_CUSTOMER_ORDER_SCHEDULES_FAILURE: {
      const customerOrderSchedulesError = action.payload.data || { message: action.payload.message };
      return { ...state, customerOrderSchedulesError, customerOrderSchedulesIsLoading: false };
    }
    case REQUEST_TODAYS_OUTGOING_ORDERS:
      return { ...state, todaysOutgoingOrdersIsLoading: true, todaysOutgoingOrdersError: null };
    case FETCH_TODAYS_OUTGOING_ORDERS_SUCCESS:
      return { ...state, todaysOutgoingOrders: action.payload.data, todaysOutgoingOrdersIsLoading: false };
    case FETCH_TODAYS_OUTGOING_ORDERS_FAILURE: {
      const todaysOutgoingOrdersError = action.payload.data || { message: action.payload.message };
      return { ...state, todaysOutgoingOrdersError, todaysOutgoingOrdersIsLoading: false };
    }
    case REQUEST_SALES_ORDER_LINE_WEIGHTS:
      return { ...state, salesOrderLineWeightsIsLoading: true, salesOrderLineWeightsError: null };
    case FETCH_SALES_ORDER_LINE_WEIGHTS_SUCCESS:
      return { ...state, salesOrderLineWeights: action.payload.data, salesOrderLineWeightsIsLoading: false };
    case FETCH_SALES_ORDER_LINE_WEIGHTS_FAILURE: {
      const salesOrderLineWeightsError = action.payload.data || { message: action.payload.message };
      return { ...state, salesOrderLineWeightsError, salesOrderLineWeightsIsLoading: false };
    }
    case REQUEST_SET_ORDER_LINE_WEIGHTS:
      return { ...state, salesOrderLineWeightsIsEditing: true, editSalesOrderLineWeightsError: null };
    case EDIT_SALES_ORDER_LINE_WEIGHTS_SUCCESS:
      return {
        ...state, salesOrderLineWeightsIsEditing: false, editSalesOrderLineWeightsSuccess: true, editSalesOrderLineWeightsError: null,
      };
    case EDIT_SALES_ORDER_LINE_WEIGHTS_FAILURE: {
      const editSalesOrderLineWeightsError = action.payload.data || { message: action.payload.message };
      return { ...state, editSalesOrderLineWeightsError: editSalesOrderLineWeightsError.errors[0], salesOrderLineWeightsIsEditing: false };
    }
    case CLEAR_SALES_ORDER_LINE_WEIGHTS:
      return {
        ...state, salesOrderLineWeightsIsEditing: false, editSalesOrderLineWeightsSuccess: false, editSalesOrderLineWeightsError: null,
      };
    case REQUEST_SALES_ORDER_FORM:
      return { ...state, printFormIsLoading: true, printFormError: null };
    case FETCH_SALES_ORDER_FORM_SUCCESS:
      window.open(`data:application/pdf,${escape(action.payload.data)}`);
      return { ...state, printForm: action.payload.data, printFormIsLoading: false };
    case FETCH_SALES_ORDER_FORM_FAILURE: {
      const printFormError = action.payload.data || { message: action.payload.message };
      return { ...state, printFormIsLoading: false, printFormError };
    }
    case REQUEST_SALES_CSV:
      return { ...state, csvIsLoading: true, csvError: null };
    case FETCH_SALES_CSV_SUCCESS:
      window.open(`data:application/pdf,${escape(action.payload.data)}`);
      return { ...state, csv: action.payload.data, csvIsLoading: false };
    case FETCH_SALES_CSV_FAILURE: {
      const csvError = action.payload.data || { message: action.payload.message };
      return { ...state, csvIsLoading: false, csvError };
    }
    case REQUEST_SAVE_POS_SALE:
      return {
        ...state, SavingPosSale: true, SavePosSaleSuccessful: null, SavePosSaleFailure: null, SavePosError,
      };
    case SAVE_POS_SALE_SUCCESS:
      return { ...state, SavingPosSale: false, SavePosSaleSuccessful: true };
    case SAVE_POS_SALE_FAILURE: {
      const SavePosError = action.payload.data || { message: action.payload.message };
      return {
        ...state, SavingPosSale: false, SavePosSaleFailure: true, SavePosError,
      };
    }
    case INVALID_CHARACTER_ENTERED:
      return { ...state, InvalidCharacterEntered: true };
    case CLEAR_ERROR_MESSAGE_IN_POS:
      return { ...state, InvalidCharacterEntered: false, ChargeNotMet: false };
    case CHARGE_NOT_MET:
      return { ...state, ChargeNotMet: true };
    case START_NEW_ORDER:
      return { ...state, SavePosSaleSuccessful: null, SavePosSaleFailure: null };
    case REQUEST_DRAFT_DETAILS:
      return {
        ...state, RequestingDraft: true, LoadDraftSuccessful: null, LoadDraftFailure: null,
      };
    case LOAD_DRAFT_SUCCESS:
      return { ...state, RequestingDraft: false, DraftDetails: action.payload.data };
    case LOAD_DRAFT_FAILURE: {
      const DraftError = action.payload.data || { message: action.payload.message };
      return { ...state, RequestingDraft: false, DraftError };
    }
    case REQUEST_DRAFTS:
      return {
        ...state, draftsIsLoading: true, drafts: null, draftsError: null,
      };
    case FETCH_DRAFTS_SUCCESSFUL:
      return { ...state, draftsIsLoading: false, drafts: action.payload.data };
    case FETCH_DRAFTS_FAILURE: {
      const draftsError = action.payload.data || { message: action.payload.message };
      return { ...state, draftsIsLoading: false, draftsError };
    }
    case REQUEST_CUSTOMER_PRICES:
      return { ...state, customerPricesIsLoading: true, customerPricesError: null };
    case FETCH_CUSTOMER_PRICES_SUCCESS:
      return { ...state, customerPricesIsLoading: false, customerPrices: action.payload.data };
    case FETCH_CUSTOMER_PRICES_FAILURE: {
      const customerPricesError = action.payload.data || { message: action.payload.message };
      return { ...state, customerPricesIsLoading: false, customerPricesError };
    }
    case REQUEST_CURRENCY_RATES:
      return {
        ...state, currencyRatesIsLoading: true, currencyRates: null, currencyRatesError: null,
      };
    case FETCH_CURRENCY_RATES_SUCCESS:
      return {
        ...state, currencyRatesIsLoading: false, currencyRates: action.payload.data, currencyRatesError: null,
      };
    case FETCH_CURRENCY_RATES_FAILURE: {
      const currencyRatesError = action.payload.data || { message: action.payload.message };
      return {
        ...state, currencyRatesIsLoading: false, currencyRates: null, currencyRatesError,
      };
    }
    case EDIT_MULTI_CURRENCIES:
      return {
        ...state, multiCurrenciesIsEditing: true, multiCurrenciesEdited: false, multiCurrenciesEditError: null,
      };
    case EDIT_MULTI_CURRENCIES_SUCCESS:
      return { ...state, multiCurrenciesIsEditing: false, multiCurrenciesEdited: true };
    case EDIT_MULTI_CURRENCIES_FAILURE: {
      const multiCurrenciesEditError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(multiCurrenciesEditError));
      return { ...state, multiCurrenciesIsEditing: false, multiCurrenciesEditError };
    }
    case REQUEST_TAX_RATES:
      return {
        ...state, taxRatesIsLoading: true, taxRates: null, taxRatesError: null,
      };
    case FETCH_TAX_RATES_SUCCESS:
      return {
        ...state, taxRatesIsLoading: false, taxRates: action.payload.data, taxRatesError: null,
      };
    case FETCH_TAX_RATES_FAILURE: {
      const taxRatesError = action.payload.data || { message: action.payload.message };
      return {
        ...state, taxRatesIsLoading: false, taxRates: null, taxRatesError,
      };
    }
    case EDIT_MULTI_TAXES:
      return {
        ...state, multiTaxesIsEditing: true, multiTaxesEdited: false, multiTaxesEditError: null,
      };
    case EDIT_MULTI_TAXES_SUCCESS:
      return { ...state, multiTaxesIsEditing: false, multiTaxesEdited: true };
    case EDIT_MULTI_TAXES_FAILURE: {
      const multiTaxesEditError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(multiTaxesEditError));
      return { ...state, multiTaxesIsEditing: false, multiTaxesEditError };
    }
    case DELETE_TAX:
      return {
        ...state, taxIsDeleting: true, taxDeleted: false, taxDeleteError: null,
      };
    case DELETE_TAX_SUCCESS:
      return { ...state, taxIsDeleting: false, taxDeleted: true };
    case DELETE_TAX_FAILURE: {
      const taxDeleteError = action.payload.data || { message: action.payload.message };
      return { ...state, taxIsDeleting: false, taxDeleteError };
    }
    case REQUEST_CREATE_TAX_RATE:
      return {
        ...state, creatingTaxRate: true, createTaxRateError: null, createTaxRateSuccess: null,
      };
    case CREATE_TAX_RATE_SUCCESS:
      return { ...state, creatingTaxRate: false, createTaxRateSuccess: true };
    case CREATE_TAX_RATE_FAILURE: {
      const createTaxRateError = action.payload.data || { message: action.payload.data };
      return { ...state, creatingTaxRate: false, createTaxRateError };
    }
    case REQUEST_OVERALL_SALES_PERFORMANCE:
      return {
        ...state, overallSalesIsLoading: true, overallSalesError: null, overallSales: [],
      };
    case FETCH_OVERALL_SALES_PERFORMANCE_SUCCESS:
      return { ...state, overallSalesIsLoading: false, overallSales: action.payload.data };
    case FETCH_OVERALL_SALES_PERFORMANCE_FAILURE: {
      const overallSalesError = action.payload.data || { message: action.payload.message };
      return { ...state, overallSalesIsLoading: false, overallSalesError };
    }
    case REQUEST_POS_REPORT:
      return {
        ...state, posReportIsLoading: true, posReport: [], posReportError: null,
      };
    case FETCH_POS_REPORT_SUCCESS:
      return { ...state, posReportIsLoading: false, posReport: action.payload.data };
    case FETCH_POS_REPORT_FAILURE: {
      const posReportError = action.payload.data || { message: action.payload.message };
      return { ...state, posReportIsLoading: false, posReportError };
    }
    case REQUEST_SALES_INVENTORY_INFO:
      return {
        ...state, salesInventoryInfoIsLoading: true, salesInventoryInfo: [], salesInventoryInfoError: null,
      };
    case FETCH_SALES_INVENTORY_INFO_SUCCESS:
      return { ...state, salesInventoryInfoIsLoading: false, salesInventoryInfo: action.payload.data };
    case FETCH_SALES_INVENTORY_INFO_FAILURE: {
      const salesInventoryInfoError = action.payload.data || { message: action.payload.message };
      return { ...state, salesInventoryInfoIsLoading: false, salesInventoryInfoError };
    }
    case REQUEST_SALES_CUSTOMER_DETAIL:
      return {
        ...state, salesCustomerDetailsIsLoading: true, salesCustomerDetails: {}, salesCustomerDetailsError: null,
      };
    case REQUEST_SALES_SHIPPING_CUSTOMER_DETAIL:
      return {
        ...state, salesCustomerDetailsIsLoading: true, salesShippingCustomerDetails: {}, salesCustomerDetailsError: null,
      };
    case FETCH_SALES_SHIPPING_CUSTOMER_DETAIL_SUCCESS:
      return { ...state, salesCustomerDetailsIsLoading: false, salesShippingCustomerDetails: action.payload.data };
    case FETCH_SALES_CUSTOMER_DETAIL_SUCCESS:
      return { ...state, salesCustomerDetailsIsLoading: false, salesCustomerDetails: action.payload.data };
    case FETCH_SALES_CUSTOMER_DETAIL_FAILURE: {
      const salesCustomerDetailsError = action.payload.data || { message: action.payload.message };
      return { ...state, salesCustomerDetailsIsLoading: false, salesCustomerDetailsError };
    }
    case REQUEST_SHIPPING_DETAIL:
      return {
        ...state, allShippingIsLoading: true, allShipping: {}, allShippingError: null,
      };
    case FETCH_SHIPPING_DETAIL_SUCCESS:
      return { ...state, allShippingIsLoading: false, allShipping: action.payload.data };
    case FETCH_SHIPPING_DETAIL_FAILURE: {
      const allShippingError = action.payload.data || { message: action.payload.message };
      return { ...state, allShippingIsLoading: false, allShippingError };
    }
    case REQUEST_PURCHASES_VENDOR_DETAIL:
      return {
        ...state, salesVendorDetailsIsLoading: true, purchasesDetails: {}, purchasesVendorDetailsError: null,
      };
    case FETCH_PURCHASES_VENDOR_DETAIL_SUCCESS:
      return { ...state, purchasesVendorDetailsIsLoading: false, purchasesVendorDetails: action.payload.data };
    case FETCH_PURCHASES_VENDOR_DETAIL_FAILURE: {
      const purchasesVendorDetailsError = action.payload.data || { message: action.payload.message };
      return { ...state, purchasesVendorDetailsIsLoading: false, purchasesVendorDetailsError };
    }
    case CLEAR_SALES_CUSTOMER_DETAILS:
      return { ...state, salesCustomerDetails: null };
    case REQUEST_ITEM_SALES_HISTORY:
      return {
        ...state, salesItemHistoryIsLoading: true, salesItemHistory: [], salesItemHistoryError: null,
      };
    case FETCH_ITEM_SALES_HISTORY_SUCCESS:
      return { ...state, salesItemHistoryIsLoading: false, salesItemHistory: action.payload.data };
    case FETCH_ITEM_SALES_HISTORY_FAILURE: {
      const salesItemHistoryError = action.payload.data || { message: action.payload.message };
      return { ...state, salesItemHistoryIsLoading: false, salesItemHistoryError };
    }
    case REQUEST_CUSTOMER_FREQUENT:
      return {
        ...state, customerFrequentIsLoading: true, customerFrequent: [], customerFrequentError: null,
      };
    case FETCH_CUSTOMER_FREQUENT_SUCCESS:
      return { ...state, customerFrequentIsLoading: false, customerFrequent: action.payload.data };
    case FETCH_CUSTOMER_FREQUENT_FAILURE: {
      const customerFrequentError = action.payload.data || { message: action.payload.message };
      return { ...state, customerFrequentIsLoading: false, customerFrequentError };
    }
    case SET_SALES_ORDERS_FILTER:
      return { ...state, salesOrdersFilter: action.payload };
    case REQUEST_SALES_PERFORMANCE_BY_FILTER:
    case REQUEST_SALES_PERFORMANCE:
      return {
        ...state, salesPerformanceIsLoading: true, salesPerformance: null, salesPerformanceError: null,
      };
    case REQUEST_SALES_PERFORMANCE_SUCCESS:
      return {
        ...state, salesPerformanceIsLoading: false, salesPerformance: action.payload.data, salesPerformanceError: null,
      };
    case REQUEST_SALES_PERFORMANCE_FAILURE: {
      const salesPerformanceError = action.payload.data || { message: action.payload.message };
      return {
        ...state, salesPerformanceIsLoading: false, salesPerformance: null, salesPerformanceError,
      };
    }
    case REQUEST_USER_PERFORMANCE_BY_FILTER:
      return {
        ...state, userPerformanceIsLoading: true, userPerformanceData: {}, userPerformanceError: null,
      };
    case REQUEST_USER_PERFORMANCE_SUCCESS:
      return {
        ...state, userPerformanceIsLoading: false, userPerformanceData: action.payload, userPerformanceError: null,
      };
    case REQUEST_USER_PERFORMANCE_FAILURE:
      return {
        ...state, userPerformanceIsLoading: false, userPerformanceData: {}, userPerformanceError: action.payload,
      };
    case REQUEST_SALES_DASHBOARD_DETAIL:
      return {
        ...state, dashboardSalesDetailError: null, dashboardSalesDetailIsLoading: true, dashboardSalesDetail: null,
      };
    case FETCH_SALES_DASHBOARD_DETAIL_SUCCESS:
      return {
        ...state, dashboardSalesDetail: action.payload.data, dashboardSalesDetailError: null, dashboardSalesDetailIsLoading: false,
      };
    case FETCH_SALES_DASHBOARD_DETAIL_FAILURE: {
      const dashboardSalesDetailError = action.payload.data || { message: action.payload.message };
      return {
        ...state, dashboardSalesDetail: null, dashboardSalesDetailError, dashboardSalesDetailIsLoading: false,
      };
    }
    case REQUEST_SALES_LEVELS:
      return {
        ...state, salesLevelsIsLoading: true, salesLevels: {}, salesLevelsError: null,
      };
    case FETCH_SALES_LEVELS_SUCCESS:
      return { ...state, salesLevelsIsLoading: false, salesLevels: action.payload.data };
    case FETCH_SALES_LEVELS_FAILURE:
      return { ...state, salesLevelsIsLoading: false, salesLevelsError: action.payload.data };
    case REQUEST_REFUND:
      return { ...state, refund: { error: null, loading: true, status: 0 } };
    case REQUEST_REFUND_SUCCESS:
      return { ...state, refund: { error: null, loading: false, status: 200 } };
    case REQUEST_REFUND_FAILURE: {
      const refundError = action.payload.data || { message: action.payload.message }; // 2nd one is network or server down errors
      return { ...state, refund: { error: refundError, loading: false, status: 400 } };
    }
    case REQUEST_PRODUCT_BY_ID:
      return {
        ...state, salesOrderProductIsLoading: true, salesOrderProduct: null, salesOrderProductFailure: null,
      };
    case FETCH_PRODUCT_BY_ID_SUCCESS:
      return { ...state, salesOrderProductIsLoading: false, salesOrderProduct: action.payload.data };
    case FETCH_PRODUCT_BY_ID_FAILURE:
      return { ...state, salesOrderProductIsLoading: false, salesOrderProductFailure: action.payload.data };

    case REQUEST_SHIPPING_LIST_PDF:
      return { ...state, requestingShippingList: true, shippingListPDF: null };
    case FETCH_SHIPPING_LIST_SUCCESS:
      return { ...state, requestingShippingList: false, shippingListPDF: action.payload.data };
    case REMOVE_SHIPPING_PDF:
      return { ...state, shippingListPDF: null };

    case REQUEST_PACKING_LIST_PDF:
      return { ...state, requestingPackingList: true, packingListPDF: null };
    case FETCH_PACKING_LIST_SUCCESS:
      return { ...state, requestingPackingList: false, packingListPDF: action.payload.data };

    case REQUEST_PICKING_LIST_PDF:
      return { ...state, requestingPickingList: true, pickingListPDF: null };
    case FETCH_PICKING_LIST_SUCCESS:
      return { ...state, requestingPickingList: false, pickingListPDF: action.payload.data };

    case REQUEST_SO_PDF:
      return { ...state, requestingSalesOrderPDF: true, salesOrderPDF: null };
    case FETCH_SO_PDF_SUCCESS:
      return { ...state, requestingSalesOrderPDF: false, salesOrderPDF: action.payload.data };
    
    case REQUEST_SO_SI_PDF:
      return { ...state, requestingSalesOrderSIPDF: true, salesOrderSIPDF: null };
    case FETCH_SO_SI_PDF_SUCCESS:
      return { ...state, requestingSalesOrderSIPDF: false, salesOrderSIPDF: action.payload.data };
        
    case REQUEST_BOL_ID_PDF:
      return { ...state, requestingBolIdPDF: true, bolIdPDF: null };
    case FETCH_BOL_ID_PDF_SUCCESS:
      return { ...state, requestingBolIdPDF: false, bolIdPDF: action.payload.data };
    
    case REQUEST_BOL_WITHOUT_LOG:
      return { ...state, requestingBolWithoutLogPDF: true, bolWithoutLogPDF: null };
    case FETCH_BOL_WITHOUT_LOG_SUCCESS:
      return { ...state, requestingBolWithoutLogPDF: false, bolWithoutLogPDF: action.payload.data };
    
    case REQUEST_BOL_LABEL:
      return { ...state, requestingBolLabel: true, bolLabel: null };
    case FETCH_BOL_LABEL_SUCCESS:
      return { ...state, requestingBolLabel: false, bolLabel: action.payload.data };
        
    case REQUEST_BOL_FBA_PDF:
      return { ...state, requestingBolFbaPDF: true, bolFbaPDF: null };
    case FETCH_BOL_FBA_PDF_SUCCESS:
      return { ...state, requestingBolFbaPDF: false, bolFbaPDF: action.payload.data };


    case REQUEST_SP_PDF:
      return { ...state, spPDF: null };
    case FETCH_SP_SUCCESS:
      return { ...state, spPDF: action.payload.data };


    case FETCH_BOL_ADDRESS_SUCCESS:
      return { ...state, bolAddress: action.payload.data };

    case REQUEST_REFUND_PDF:
      return { ...state, requestingRefundPDF: true, refundPDF: null };
    case REQUEST_REFUND_PDF_SUCCESS:
      return { ...state, requestingRefundPDF: false, refundPDF: action.payload.data };

    case KEEP_EST_DATE:
      return {
        ...state, prevEstDate: action.payload.date, salesOrderEdited: false, salesOrderCreated: false, detailIsLoading: true, prevEstDateIsNeeded: true,
      };
    case FINISHED_UNMOUNT:
      return { ...state, detailIsLoading: false };
    case DESTROY_EST_DATE:
      return {
        ...state, prevEstDate: null, salesOrderEdited: false, salesOrderCreated: false, prevEstDateIsNeeded: false,
      };

    case REQUEST_SALES_TOTALS:
      return {
        ...state, salesTotalsIsLoading: true, salesTotals: null, salesTotalsError: null,
      };
    case FETCH_SALES_TOTALS_SUCCESS:
      return {
        ...state, salesTotalsIsLoading: false, salesTotals: action.payload.data,
      };
    case FETCH_SALES_TOTALS_FAILURE:
      return {
        ...state, salesTotalsIsLoading: false, salesTotalsError: action.payload.data,
      };
    case REQUEST_SALES_ORDER_TO_QUOTE:
      return {
        ...state, error: null, quoteLoading: true,
      };
    case SALES_ORDER_TO_QUOTE_SUCCESS:
      return {
        ...state, quoteLoading: false,
      };
    case SALES_ORDER_TO_QUOTE_FAILURE: {
      const sToOerror = action.payload.data || { message: action.payload.message };
      return {
        ...state, error: sToOerror, quoteLoading: false,
      };
    }
    case REQUEST_SALES_QUOTE_TO_OPEN:
      return {
        ...state, error: null, quoteLoading: true,
      };
    case REQUEST_SALES_QUOTE_TO_ORDER_SUCCESS:
      return {
        ...state, quoteLoading: false,
      };
    case REQUEST_SALES_QUOTE_TO_ORDER_FAILURE: {
      const qToSerror = action.payload.data || { message: action.payload.message };
      return {
        ...state, quoteLoading: false, error: qToSerror,
      };
    }
    case UPDATE_CURRENT_SALES_ORDER_DETAIL_SHIPPINGINFO:
      return { ...state, currentSalesOrderDetail: { ...state.currentSalesOrderDetail, Shipping: action.payload } };
    case SALES_ORDER_FORM_BATCHES:
      return {
        ...state,
        batchesInfo: action.payload,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/salesOrders_reducer.js